
import React from 'react';

interface InputFieldProps {
    label: string;
    placeholder?: string;
    type?: string;
    name: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    required?: boolean;
    className?: string;
    icon?: React.ReactNode;
    multiline?: boolean;
}

export const InputField: React.FC<InputFieldProps> = ({
    label,
    placeholder,
    type = 'text',
    name,
    value,
    onChange,
    required,
    className = '',
    icon,
    multiline = false,
}) => {
    return (
        <div className={`flex flex-col gap-1 ${className}`}>
            {label && (
                <label htmlFor={name} className="block text-xs font-normal mb-0.5 text-[#888888]">
                    {label}
                </label>
            )}
            <div className={`relative flex items-center ${multiline ? '' : ''}`}>
                {icon && !multiline && (
                    <span className="absolute left-3 top-1/2 transform -translate-y-1/2">{icon}</span>
                )}
                {multiline ? (
                    <textarea
                        id={name}
                        name={name}
                        value={value}
                        onChange={onChange}
                        placeholder={placeholder}
                        required={required}
                        className={`w-full border border-gray-300 rounded-lg px-4 py-2 text-xs bg-white text-[#888888] focus:outline-none focus:ring-2 focus:ring-maxi-green min-h-[80px] resize-none`}
                    />
                ) : (
                    <input
                        id={name}
                        name={name}
                        type={type}
                        value={value}
                        onChange={onChange}
                        placeholder={placeholder}
                        required={required}
                        className={`w-full border border-gray-300 rounded-lg px-4 py-3 text-xs bg-white text-[#888888] focus:outline-none focus:ring-2 focus:ring-maxi-green ${icon ? 'pl-10' : ''}`}
                    />
                )}
            </div>
        </div>
    );
};
